module.exports = __webpack_public_path__ + "static/fiji1-768x681-5aaa8cd8231433526da251104a943656.png";